import { apiJson } from './api';
import type { QuickAccessLaw } from '@/types';

export async function getQuickAccessLaws(): Promise<QuickAccessLaw[]> {
  const data = await apiJson<{ quickAccessLaws: QuickAccessLaw[] }>('/api/mobile/quick-access');
  return data.quickAccessLaws ?? [];
}

export async function syncQuickAccessToServer(laws: QuickAccessLaw[]): Promise<void> {
  await apiJson('/api/mobile/quick-access', {
    method: 'POST',
    body: JSON.stringify({ quickAccessLaws: laws }),
  });
}

/** Añade una ley a accesos rápidos (evita duplicados por lawId). */
export async function addQuickAccessLaw(lawId: string, lawTitle: string): Promise<void> {
  const current = await getQuickAccessLaws();
  if (current.some((l) => l.lawId === lawId)) return;
  const added: QuickAccessLaw = {
    lawId,
    lawTitle,
    addedAt: new Date().toISOString(),
  };
  await syncQuickAccessToServer([...current, added]);
}
